const mutations = {
    // 设置状态
    SET_STATE(state, { key, val }) {
        state[key] = val;
    },
    // 显示弹窗
    SHOW_POPUP(state, name) {
        state.popup[name] = true;
    },
    // 隐藏弹窗
    HIDE_POPUP(state, name) {
        state.popup[name] = false;
    },
    // 隐藏所有弹窗
    HIDE_ALL_POPUP(state) {
        for (let key of Object.keys(state.popup)) {
            state.popup[key] = false;
        }
    },
    // 更换语言
    SET_LANG(state, lang) {
        state.lang = lang;
    },
    // 设置userinfo
    SET_USERINFO(state, data) {
        for (let key in data) {
            state.userinfo[key] = data[key];
        }
    },
    SET_GAME_STATE(state, { key, value }) {
        state.game[key] = value;
    },
    // 记录游戏
    SET_GAME(state, gameAni) {
        state.gameAni = gameAni;
        state.game.canPk = true;
    },
    SET_GAME_VIEW(state, view) {
        state.game.view = view;
    },
    // pk状态
    SET_PK_STATE(state, canPk) {
        state.game.canPk = canPk;
    },
    // 显示
    SHOW_CODE_POPUP(state, payload) {
        state.popup['code'] = true;
        state.codeReward = payload;
    },
    PLAY_SOUND(state, soundid) {
        state.bgmPlayState && createjs.Sound.play(soundid);
    },
    STOP_SOUND(state) {
        state.bgmPlayState && createjs.Sound.stop();
    }
};

export default mutations;
